@if (config?.showSummaryRow) {
  <section
    class="DatagridSummaryRow DatagridSummaryRow__row__wrapper"
    role="row"
  >
    <div class="DatagridSummaryRow__row">
      @for (column of config?.columns; track $index) {
        <div
          class="DatagridSummaryRow__cell"
          [ngClass]="{
            'DatagridSummaryRow__cell--ellipsis': column.width,
            'DatagridSummaryRow__cell--alignRight': column.isRightAligned,
            'DatagridSummaryRow__cell--alignLeft': column.isLeftAligned,
            'DatagridSummaryRow__cell--alignCenter':
              column.isCenterAligned ||
              (!column.isLeftAligned && !column.isRightAligned),
          }"
          [ngStyle]="{
            width: getColumnWidth(column),
            'min-width': getColumnWidth(column),
            'max-width': getColumnWidth(column),
          }"
          role="cell"
        >
          <p
            class="t-bold"
            [innerHTML]="$index === 0 ? 'Total' : getTotalValue(rows, column)"
          ></p>
        </div>
      }
    </div>
  </section>
}
